import React from 'react'

export default function Contact() {
  return (
    <div className="mainpage">Contact</div>
  )
}
